import { MdHomeFilled } from "react-icons/md";
import { DefaultLayout } from "../../layouts";
import { ResidentialMortgageScreen, TitleSection } from "../../components";

export default function ResidentialMortgage() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "Services", link: "#" },
    { title: "Residential Mortgage", link: "#" },
  ];

  return (
    <DefaultLayout>
      <TitleSection
        title="Services"
        bg="/images/residential-mortgage-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <ResidentialMortgageScreen />
    </DefaultLayout>
  );
}
